import { dynamicFilterFilter } from "app/filters/dynamicFilter";
import type { FC } from "react";

interface ILargeNumberCellTemplate {
    data: any;
    row: any;
}
export const LargeNumberCellTemplateV2: FC<ILargeNumberCellTemplate> = (props) => {
    const { data, row } = props;

    return <div className="u-blueMediumMedium u-fontLarge">{dynamicFilterFilter()(data[row.field], row.format)}</div>;
};
